import React from "react";
import { withNamespaces } from 'react-i18next';

const AcVidaacademica = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_vida">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vida_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vida_collapse1"
              aria-expanded="true"
              aria-controls="vida_collapse1"
            >
              {t('moduleFaqs:S8.A.A1.T') }
            </button>
          </h2>
          <div
            id="vida_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="vida_heading1"
            data-bs-parent="#accordionExample_vida"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A1.P1') }}></p>
              <p className="p_accordion">{t('moduleFaqs:S8.A.A1.P2') }</p>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vida_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vida_collapse2"
              aria-expanded="false"
              aria-controls="vida_collapse2"
            >
              {t('moduleFaqs:S8.A.A2.T') }
            </button>
          </h2>
          <div
            id="vida_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="vida_heading2"
            data-bs-parent="#accordionExample_vida"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A2.P1') }}></p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vida_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vida_collapse3"
              aria-expanded="false"
              aria-controls="vida_collapse3"
            >
              {t('moduleFaqs:S8.A.A3.T') }
            </button>
          </h2>
          <div
            id="vida_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="vida_heading3"
            data-bs-parent="#accordionExample_vida"
          >
            <div className="accordion-body">
              <p className="p_accordion" >

                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A3.P1') }}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S8.A.A3.Link.Link')} title={t('moduleFaqs:S8.A.A3.Link.Title')}>{t('moduleFaqs:S8.A.A3.Link.NameLink')}</a>
                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A3.P2') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vida_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vida_collapse4"
              aria-expanded="false"
              aria-controls="vida_collapse4"
            >
              {t('moduleFaqs:S8.A.A4.T') }
            </button>
          </h2>
          <div
            id="vida_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="vida_heading4"
            data-bs-parent="#accordionExample_vida"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A4.P1') }}></p>
            </div>
          </div>
        </div>
        {/* 5*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vida_heading5">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vida_collapse5"
              aria-expanded="false"
              aria-controls="vida_collapse5"
            >
              {t('moduleFaqs:S8.A.A5.T') }
            </button>
          </h2>
          <div
            id="vida_collapse5"
            className="accordion-collapse collapse"
            aria-labelledby="vida_heading5"
            data-bs-parent="#accordionExample_vida"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S8.A.A5.P1') }}></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcVidaacademica);
